<template>
  <v-dialog v-model="dialog" max-width="350" persistent>
    <v-card :loading="cargas.carregando">
      <v-card-title class="font-weight-bold">Alterar placa</v-card-title>
      <template v-if="cargaSelec">
        <v-card-text>
          <v-form ref="form">
            <v-autocomplete
              label="Placa"
              :items="listaPlacas.dados.filter((p) => p != cargaSelec.placa)"
              auto-select-first
              v-model="placaAlterar"
              autofocus
              no-data-text=""
            ></v-autocomplete>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            rounded
            color="success"
            :loading="alterando"
            @click="alterarPlaca()"
            >Confirmar</v-btn
          >
          <v-btn
            text
            rounded
            color="secondary"
            @click="dialog = false"
            :disabled="alterando"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("formacaoCarga", ["listaPlacas", "cargas", "cargaSelec"]),
  },
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  data: () => ({
    dialog: false,
    alterando: false,
    placaAlterar: "",
  }),
  methods: {
    ...mapMutations("formacaoCarga", ["setCarga", "setIdCarga", "setAltPlaca"]),
    ...mapActions("formacaoCarga", ["buscarVeiculo", "buscarCargas"]),
    async alterarPlaca() {
      if (this.$refs.form.validate()) {
        this.alterando = true;
        await axios
          .put(
            "/nutricao-animal/formacao-carga/cargas",
            {
              placa: this.placaAlterar,
            },
            {
              params: {
                id: this.$route.params.id,
                funcao: "ALTERAR-PLACA",
              },
            }
          )
          .then(async (res) => {
            if (res.data.success) {
              this.setAltPlaca(true)              
              this.dialog = false;
            } else {
              this.$toasted.error(res.data.msg);
            }
          })
          .catch((e) => this.$toasted.error(e))
          .finally(() => (this.alterando = false));
      }
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>